interface Props {
  width?: string;
  height?: string;
  fill?: string;
  className?: string;
}

const Client = ({
  fill = '#1a1818',
  height = '31.55',
  width = '25.204',
  className,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 25.204 31.55"
    className={className}
    transform="scale(0.9)"
  >
    <g id="Group_438" transform="translate(-291.67 -411.809)">
      <g id="Group_337" transform="translate(-722.544 -921.173)">
        <path
          id="Path_678"
          d="M1038.668,1364.532a.75.75,0,0,1-.75-.75c0-6.551-4.981-11.88-11.1-11.88s-11.1,5.329-11.1,11.88a.75.75,0,0,1-1.5,0c0-7.378,5.653-13.38,12.6-13.38s12.6,6,12.6,13.38A.75.75,0,0,1,1038.668,1364.532Z"
          fill={fill}
        />
      </g>
      <g id="Group_338" transform="translate(-722.544 -921.173)">
        <path
          id="Path_679"
          d="M1027.256,1348.4a7.709,7.709,0,1,1,7.71-7.709A7.718,7.718,0,0,1,1027.256,1348.4Zm0-13.919a6.209,6.209,0,1,0,6.21,6.21A6.217,6.217,0,0,0,1027.256,1334.482Z"
          fill={fill}
        />
      </g>
    </g>
  </svg>
);

export default Client;
